export interface C24AppVersion {
    appPlatform: string;
    appName: string;
    major: number;
    minor: number;
    hotfix: number | null;
    build?: number | null;
}

export class C24AppVersionParser {
    private static PATTERN =
        /(?<AppPlatform>(iOS|Android))-(?<AppName>(Vergleiche|CHECK24))-(?<AppVersion>.+)/;
    private static VERSION_PATTERN =
        /(?<Major>(\d+)).(?<Minor>(\d+))(.(?<Hotfix>(\d+))(.(?<Build>(\d+)))?)?/;

    static parseC24AppVersion(c24appversion: string): C24AppVersion {
        const matches = c24appversion.match(C24AppVersionParser.PATTERN);

        if (!matches) {
            throw new Error("Could not match the pattern");
        }

        const appPlatform = matches.groups?.AppPlatform?.toLowerCase();
        const appName = matches.groups?.AppName;

        if (!appPlatform || !appName) {
            throw new Error("Invalid appPlatform or appName");
        }

        const versionMatches = matches.groups?.AppVersion.match(
            C24AppVersionParser.VERSION_PATTERN,
        );

        if (!versionMatches) {
            throw new Error("Could not match version pattern");
        }

        const versionProps = ["Major", "Minor", "Hotfix", "Build"];
        const versionValues = versionProps.map((prop) =>
            parseInt(versionMatches.groups?.[prop] || "0", 10),
        );

        return {
            appPlatform,
            appName,
            major: versionValues[0],
            minor: versionValues[1],
            hotfix: versionValues[2] || null,
            build: versionValues[3] || null,
        };
    }
}
